import { SearchDomains } from '../components/contexts/SearchContext'
import { StructureType, StructureTypes } from '../models/Structure'

export const buildNavigationLink = (slug: string, id: string) => {
    if (!(slug && id)) return '/'
    return `/${slug}/${id}`
}

export const buildStructureLink = (type: StructureType, id: string) => {
    const slug = (() => {
        switch (type) {
            case StructureTypes.Project:
                return 'project'
            case StructureTypes.BoltConnection:
                return 'connection'
            case StructureTypes.Bolt:
                return 'bolt'
            case StructureTypes.None:
            default:
                return ''
        }
    })()
    return buildNavigationLink(slug, id)
}

export const buildNewStructureLink = (type: StructureType, id: string) => {
    const allowedNewStructureTypes: StructureType[] = [
        StructureTypes.Project,
        StructureTypes.BoltConnection,
    ]

    if (!allowedNewStructureTypes.includes(type)) return '/'
    return buildStructureLink(type, id) + '?new=' + id
}

export const buildSearchLink = (domain: string, id: string) => {
    const slug = (() => {
        switch (domain) {
            case SearchDomains.User:
                return 'users'
            case SearchDomains.Project:
                return 'project'
            case SearchDomains.BoltConnection:
                return 'connection'
            case SearchDomains.Bolt:
                return 'bolt'
            default:
                return ''
        }
    })()
    return buildNavigationLink(slug, id)
}
